import createIcon from '../../createIcon';

/**
 * @component @name DoDisturbOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuMzA0OCAxMC42OTUzVjEyLjY5NTNIMTYuMTM0OEwyMC42NDQ4IDE3LjIwNTNDMjEuNjk0OCAxNS42MjUzIDIyLjMwNDggMTMuNzM1MyAyMi4zMDQ4IDExLjY5NTNDMjIuMzA0OCA2LjE3NTMxIDE3LjgyNDggMS42OTUzMSAxMi4zMDQ4IDEuNjk1MzFDMTAuMjY0OCAxLjY5NTMxIDguMzc0ODIgMi4zMDUzMSA2Ljc5NDgyIDMuMzU1MzFMMTQuMTM0OCAxMC42OTUzSDE3LjMwNDhaTTEuNjk0ODIgMy45MTUzMUwzLjk2NDgyIDYuMTg1MzFDMi45MTQ4MiA3Ljc2NTMxIDIuMzA0ODIgOS42NTUzMSAyLjMwNDgyIDExLjY5NTNDMi4zMDQ4MiAxNy4yMTUzIDYuNzg0ODIgMjEuNjk1MyAxMi4zMDQ4IDIxLjY5NTNDMTQuMzQ0OCAyMS42OTUzIDE2LjIzNDggMjEuMDg1MyAxNy44MTQ4IDIwLjAzNTNMMjAuMDg0OCAyMi4zMDUzTDIxLjQ5NDggMjAuODk1M0wzLjExNDgyIDIuNTA1MzFMMS42OTQ4MiAzLjkxNTMxWk03LjMwNDgyIDEwLjY5NTNIOC40NzQ4MkwxMC40NzQ4IDEyLjY5NTNINy4zMDQ4MlYxMC42OTUzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DoDisturbOff = createIcon('DoDisturbOff', [
  [
    'path',
    {
      d: 'M17.3048 10.6953V12.6953H16.1348L20.6448 17.2053C21.6948 15.6253 22.3048 13.7353 22.3048 11.6953C22.3048 6.17531 17.8248 1.69531 12.3048 1.69531C10.2648 1.69531 8.37482 2.30531 6.79482 3.35531L14.1348 10.6953H17.3048ZM1.69482 3.91531L3.96482 6.18531C2.91482 7.76531 2.30482 9.65531 2.30482 11.6953C2.30482 17.2153 6.78482 21.6953 12.3048 21.6953C14.3448 21.6953 16.2348 21.0853 17.8148 20.0353L20.0848 22.3053L21.4948 20.8953L3.11482 2.50531L1.69482 3.91531ZM7.30482 10.6953H8.47482L10.4748 12.6953H7.30482V10.6953Z',
      key: 'dkxa7x',
    },
  ],
]);

export default DoDisturbOff;
